﻿var zisweb = (function () {
    'use strict';

    const zisweb = {
        loadExternalScript: null,
        showTutorial: null

    };

    zisweb.loadExternalScript = loadExternalScript;
    zisweb.showTutorial = showTutorial;


    var lizenzverwaltungDriver = null;
    function showTutorial(targetUrl) {

        var hasFloating = false;
        var floatingLic = document.getElementsByClassName('onboarding-benutzerverwaltung-action-column-floating');
        var floatingUser = document.getElementsByClassName('onboarding-zis-floating-column');

        if (floatingLic.length != 0 && floatingUser.length != 0) {
            hasFloating = true;
        }

        let customSteps = [];

        customSteps.push(
            {
                popover:
                {
                    showProgress: false,
                    popoverClass: 'zis-driver-theme-start',
                    showButtons: ["next"],
                    title: 'Willkommen in der Lizenzverwaltung!',
                    description: 'Wir möchten Ihnen gerne eine kurze Einführung in die Funktionsweise der Lizenzverwaltung geben.'
                }
            }
        );

        // Step 1
        customSteps.push(
            {
                element: '.onboarding-benutzerverwaltung-action-column',
                popover:
                {
                    showProgress: true,
                    popoverClass: 'zis-driver-theme',
                    title: 'Aktionen',
                    description: 'Innerhalb der Aktionsspalte können u.a. Lizenzen vergeben, Rollen geändert und Benutzer entfernt werden.',
                    side: "left",
                    align: 'end'
                }
            }
        );


        // Step 2 & 3
        if (hasFloating == 1) {
            customSteps.push({
                element: '.onboarding-benutzerverwaltung-action-column-floating',
                popover:
                {
                    showProgress: true,
                    popoverClass: 'zis-driver-theme',
                    title: 'Berechtigung Floating',
                    description: 'Aktivieren Sie die Schaltfläche, um die Nutzung von Floating-Lizenzen zu erlauben.',
                    side: "left",
                    align: 'end'
                }
            });

            customSteps.push({
                element: '.onboarding-zis-floating-column',
                popover:
                {
                    showProgress: true,
                    popoverClass: 'zis-driver-theme',
                    title: 'Floating-Pool',
                    description: 'Ordnen Sie hier einzelne Lizenzen dem Floating-Pool zu. Benutzer mit der entsprechenden Freigabe haben Zugriff auf diese Lizenzen',
                    side: "top",
                    align: 'end'
                }
            });
        }

        // Step 4
        customSteps.push(
            {
                element: '#onboarding-benutzer-einladen',
                popover:
                {
                    showProgress: true,
                    popoverClass: 'zis-driver-theme',
                    title: 'Benutzer hinzufügen',
                    description: 'Über diesen Button laden Sie neue Benutzer zur Teilnahme am Vertrag ein oder fügen Benutzer aus bereits bestehenden Verträgen hinzu.',
                    side: "top",
                    align: 'center'
                }
            }
        );

        // Step 5
        customSteps.push(
            {
                element: '#lizenzverwaltung-benutzerverwaltung-table',
                popover:
                {
                    showProgress: true,
                    popoverClass: 'zis-driver-theme',
                    title: 'Erweiterte Benutzeraktionen',
                    description: 'Ein Klick auf einen Benutzer öffnet die Aktionen: Lizenz entziehen, Gerät lösen, offline aktivieren und Notiz bearbeiten.',
                    side: "top",
                    align: 'center'
                }
            }
        );

        //let customSteps = [
        //    {
        //        popover:
        //        {
        //            showProgress: false,
        //            popoverClass: 'zis-driver-theme-start',
        //            showButtons: ["next"],
        //            title: 'Willkommen in der Lizenzverwaltung!',
        //            description: 'Wir möchten Ihnen gerne eine kurze Einführung in die Funktionsweise der Lizenzverwaltung geben.'
        //        }
        //    },
        //    {
        //        element: '#onboarding-table-vertraege',
        //        popover:
        //        {
        //            showProgress: true,
        //            popoverClass: 'zis-driver-theme',
        //            title: 'Vertragsübersicht',
        //            description: 'In diesem Bereich werden Ihre Verträge angezeigt. Die Vertragsliste unterscheidet zwischen Eigene Verträge und externe Verträge in denen Sie Vertragsteilnehmer sind.',
        //            side: "top",
        //            align: 'center'
        //        }
        //    },
        //    {
        //        element: '#zis-container-lizenzen',
        //        popover:
        //        {
        //            showProgress: true,
        //            popoverClass: 'zis-driver-theme',
        //            title: 'Lizenzübersicht',
        //            description: 'Die Lizenzliste zeigt die in Ihrem Vertrag enthaltenen Lizenzen und den aktuellen Status an (Frei/Benutzerbezogen/Floating)',
        //            side: "top",
        //            align: 'center'
        //        }
        //    },
        //    {
        //        element: '#onboarding-benutzer-einladen',
        //        popover:
        //        {
        //            showProgress: true,
        //            popoverClass: 'zis-driver-theme',
        //            title: 'Benutzer hinzufügen',
        //            description: 'Über diesen Button laden Sie neue Benutzer zur Teilnahme am Vertrag ein oder fügen Benutzer aus bereits bestehenden Verträgen hinzu.',
        //            side: "top",
        //            align: 'center'
        //        }
        //    },
        //    {
        //        element: '#lizenzverwaltung-benutzerverwaltung-table',
        //        popover:
        //        {
        //            showProgress: true,
        //            popoverClass: 'zis-driver-theme',
        //            title: 'Benutzerübersicht',
        //            description: 'Über die Benutzerverwaltung managen Sie Ihre Benutzer und Lizenzen. Die Benutzerliste zeigt Ihnen Infos zu allen Benutzern des aktuellen Vertrags. Ein Klick auf einen Benutzer öffnet weitere Infos und Aktionen',
        //            side: "top",
        //            align: 'center'
        //        }
        //    },
        //    {
        //        element: '.onboarding-benutzerverwaltung-action-column',
        //        popover:
        //        {
        //            showProgress: true,
        //            popoverClass: 'zis-driver-theme',
        //            title: 'Aktionen',
        //            description: 'Innerhalb der Aktionsspalte können u.a. Lizenzen vergeben, Rollen geändert und Benutzer entfernt werden.',
        //            side: "left",
        //            align: 'end'
        //        }
        //    }
        //];






        lizenzverwaltungDriver = driver({
            nextBtnText: 'Weiter',
            prevBtnText: 'Zurück',
            doneBtnText: 'Schließen',
            progressText: 'Schritt {{current}}/{{total}}',
            allowClose: false,
            overlayOpacity: '0.5',
            overlayColor: 'black',
            stagePadding: 2,
            stageRadius: 4,
            onPrevClick: () => {
                lizenzverwaltungDriver.movePrevious();
                lizenzverwaltungDriver.refresh();
            },
            onNextClick: () => {
                lizenzverwaltungDriver.moveNext();
                lizenzverwaltungDriver.refresh();
            },
            steps: customSteps,
            onDestroyed: () => {
                // only submit if the submit target link was appended
                if (targetUrl) {
                    var headers = {
                        'Content-Type': 'application/json'
                    };
                    var body = {
                        tutorialType: 0
                    };

                    htmx.ajax('POST', targetUrl, headers, JSON.stringify(body));
                }

            },
        });

        lizenzverwaltungDriver.drive();
    }


    function loadExternalScript(src, targetId) {
        console.log('SRC:: ' + src);
        console.log('TARG:: ' + targetId);
        if (!document.querySelector(`script[src="${src}"]`)) {
            const script = document.createElement('script');
            script.src = src;
            script.async = false;

            script.onload = () => {
                
            };

            script.onerror = () => {
                console.error(`Failed to load script: ${src}`);
            };

            let targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.appendChild(script); // Append to the specific target
            } else {
                document.body.appendChild(script); // Default to the body
            }
        }
    }

    function configureAltcha() {
        document.querySelectorAll('altcha-widget').forEach(widget => {
            widget.configure({
                strings: {
                    "ariaLinkLabel": "Besuchen Sie zisingbau.de",
                    "error": "Verifizierung fehlgeschlagen. Bitte versuchen Sie es später erneut.",
                    "expired": "Verifizierung abgelaufen. Bitte erneut versuchen.",
                    "footer": "Geschützt durch <a href=\"https://zisingbau.de/\" target=\"_blank\" aria-label=\"Besuchen Sie zisingbau.de\">ZIS Ing-Bau</a>",
                    "label": "Ich bin kein Roboter",
                    "verified": "Verifiziert",
                    "verifying": "Wird überprüft...",
                    "waitAlert": "Wird überprüft... bitte warten."
                },
            });
        });
    }

    function autoExecutes() {
        const currentHref = window.location.href.split('?')[0];

        // Define main paths that should be highlighted on sub-navigation
        const highlightPaths = ['/dokumentation', '/downloads'];

        document.querySelectorAll("#navigation a, #mobile-nav-container a").forEach(element => {
            const href = element.getAttribute('href');

            if (!href) return;

            // Check if the current URL matches exactly or is a sub-page of a main path
            if (currentHref.endsWith(href) || highlightPaths.some(path => currentHref.includes(path) && href.includes(path))) {
                element.classList.add("zis-navigation-active-link");
            } else {
                element.classList.remove("zis-navigation-active-link");
            }
        });

        document.querySelectorAll("#zis-subnavigation a").forEach(element => {
            const href = element.getAttribute('href');
            if (currentHref.endsWith(href)) {
                element.classList.add("zis-subnavigation-active-link");
            } else {
                element.classList.remove("zis-subnavigation-active-link");
            }
        });

        configureAltcha();
    }

    // Clear up listener!
    document.removeEventListener('htmx:afterSettle', autoExecutes);
    document.removeEventListener('DOMContentLoaded', autoExecutes);
    document.addEventListener('htmx:afterSettle', autoExecutes);
    document.addEventListener('DOMContentLoaded', autoExecutes);

    return zisweb;
})();

window.zisweb = zisweb;
export default zisweb;
